"use client";

import {
  ANALYTICS_TOOLS,
  type AnalyticsToolId,
} from "@/components/analytics-workspace/analytics-tools";
import dynamic from "next/dynamic";
import { ShowcaseTabs, type ShowcaseTab } from "./showcase-tabs";

const AnalyticsWindow = dynamic(
  () => import("./analytics-window").then((m) => m.AnalyticsWindow),
  {
    ssr: false,
    loading: () => (
      <div className="mx-auto h-[640px] w-full max-w-[1040px] rounded-t-xl border border-b-0 border-neutral-200 bg-white" />
    ),
  },
);

const TOOL_TEXT: Record<AnalyticsToolId, { title: string; text: string }> = {
  pages: {
    title: "Pages",
    text: "Every page by reach, time or taps, with the biggest drop called out. Overlays put taps and attention on the page itself.",
  },
  overview: {
    title: "Overview",
    text: "Views, average time, how many read to the end and how many found it helpful, with reach per page and views over time.",
  },
  audience: {
    title: "Audience",
    text: "Devices, session length and browser languages of everyone who opened the handyout.",
  },
  feedback: {
    title: "Feedback",
    text: "Ratings from 0 to 10 in four dimensions, and the latest comments with the page they were left on.",
  },
};

const TABS: ShowcaseTab[] = ANALYTICS_TOOLS.map((tool) => {
  const Icon = tool.icon;
  return {
    value: tool.id,
    icon: <Icon />,
    title: TOOL_TEXT[tool.id].title,
    text: TOOL_TEXT[tool.id].text,
    content: <AnalyticsWindow tool={tool.id} />,
  };
});

export function AnalyticsShowcase() {
  return <ShowcaseTabs tabs={TABS} />;
}
